import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { authorizedAtom, checkAuth } from './lib';

export function useAuthorizationStatus() {
  const [isAuthorized] = useAtom(authorizedAtom);

  useEffect(() => {
    checkAuth();
  }, []);

  return { isAuthorized };
}
